import { History, X } from 'lucide-react';
import type { ReactNode } from 'react';
import { Button } from '@/components/ui/button';

/**
 * OverlayPage (document 05, pattern 3): full-screen transaction form over the list, title and
 * close × at the top, sticky footer bar with left / centre / right action groups.
 */
export function OverlayPage({
  title,
  subtitle,
  onClose,
  children,
  footerLeft,
  footerCentre,
  footerRight,
}: {
  title: ReactNode;
  subtitle?: ReactNode;
  onClose: () => void;
  children: ReactNode;
  footerLeft?: ReactNode;
  footerCentre?: ReactNode;
  footerRight?: ReactNode;
}) {
  return (
    <div className="fixed inset-0 z-40 flex flex-col bg-background" role="dialog" aria-modal="true">
      <header className="flex h-14 shrink-0 items-center gap-3 border-b bg-card px-3 md:px-6">
        <History className="size-5 shrink-0 text-muted-foreground" aria-hidden />
        <h1 className="truncate text-lg font-semibold md:text-xl">{title}</h1>
        {subtitle ? (
          <div className="min-w-0 truncate text-sm text-muted-foreground">{subtitle}</div>
        ) : null}
        <Button
          variant="ghost"
          size="icon"
          className="ml-auto"
          aria-label="Close"
          onClick={onClose}
        >
          <X className="size-5" />
        </Button>
      </header>
      <div className="flex-1 overflow-y-auto px-4 py-4 md:px-6 md:py-6">{children}</div>
      {/* on a phone the right-hand (primary) actions take the first row, the rest wrap below */}
      <footer className="flex shrink-0 flex-wrap items-center gap-2 border-t bg-card px-3 py-2 shadow-[0_-4px_16px_rgba(17,24,39,0.08)] md:h-16 md:flex-nowrap md:px-6 md:py-0">
        <div className="flex flex-wrap items-center gap-2 md:flex-1">{footerLeft}</div>
        <div className="flex flex-wrap items-center gap-2">{footerCentre}</div>
        <div className="order-first flex w-full flex-wrap items-center justify-end gap-2 md:order-none md:w-auto md:flex-1">
          {footerRight}
        </div>
      </footer>
    </div>
  );
}
